import React, { memo, useMemo } from 'react';
import ProgressiveImage from '../../Image/ProgressiveImage';

const LISTING_CARD_SIZES = '(max-width: 600px) 100vw, (max-width: 960px) 50vw, 25vw';

const ListingCardImageComponent = ({
  addHelmet = true,
  image,
  title,
  alt = '',
  disableBlur = false,
}) => {
  const variants = image.attributes.variants;
  const imageUrl = variants['landscape-crop']?.url || '';
  const image2xUrl = variants['landscape-crop2x']?.url || '';
  const srcset = useMemo(() => {
    const parts = [];
    if (imageUrl) parts.push(`${imageUrl} 640w`);
    if (image2xUrl) parts.push(`${image2xUrl} 800w`);
    return parts.join(', ');
  }, [imageUrl, image2xUrl]);
  const imageStyle = useMemo(() => ({}), []);
  return (
    <ProgressiveImage
      addHelmet={addHelmet}
      alt={alt}
      disableBlur={disableBlur}
      imageStyle={imageStyle}
      sizes={LISTING_CARD_SIZES}
      src={imageUrl}
      srcset={srcset}
      title={title}
    />
  );
};

ListingCardImageComponent.displayName = 'ListingCardImage';

const ListingCardImage = memo(ListingCardImageComponent);

export default ListingCardImage;
